'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.hoursFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/date/hoursFromNow.js